import { useEffect } from 'preact/hooks';
import { TokenRefreshResponseModel } from '@ccmn/rhino';
import { useRhino, useStore } from 'src/hooks';

const REFRESH_INTERVAL = 15 * 60 * 1000;

const RefreshToken = () => {
    const ctx = useStore();
    const client = useRhino();
    useEffect(() => {
        const interval = setInterval(() => {
            if (ctx.user.token.value) {
                client.session.chathostRefreshToken().then((refreshedToken: TokenRefreshResponseModel) => {
                    ctx.user.token.value = refreshedToken.token;
                });
            }
        }, REFRESH_INTERVAL);
        return () => {
            clearInterval(interval);
        };
    }, [ctx, client]);

    return null;
};

export default RefreshToken;
